import { AxiosResponse } from "axios";
import { useMutation } from "react-query";
import { useHttpClient } from "../../../../shared/http/HttpClientProvider";
import { MutationOptions, MutationResult } from "../../../../shared/types/query";
import { SipUserFormData } from "../types/sip-user";

export function useUpdateSipUser(options?: MutationOptions<SipUserFormData, AxiosResponse<any>>): MutationResult<SipUserFormData, AxiosResponse<any>> {
  const http = useHttpClient();

  return useMutation({
    ...options,
    mutationKey: ['users/updateSipUser'],
    mutationFn: (data: SipUserFormData) => {
      return http.request({
        method: 'PUT',
        url: `SipUser/${data.extension}`,
        data,
      })
    }
  })
}
